export default __webpack_public_path__ + "static/media/raster-center-point-icon.03352c59.svg";